<mat-card appearance="outlined" class="mat-elevation-z4 mat-card-scrollable">
    <mat-card-header>
        <mat-card-title>{{ 'Dashboard.Top10Transactions' | translate }}</mat-card-title>
        <mat-card-subtitle>{{ 'Transactions.TopTransactionsLastNDays' | translate: { value: '30' } }}</mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
        <table mat-table [dataSource]="topTransactions">
            <ng-container matColumnDef="valueDate">
                <th mat-header-cell *matHeaderCellDef>{{ 'General.Date' | translate }}</th>
                <td mat-cell *matCellDef="let item">
                    {{ item.valueDate | localizedDate: 'shortDate' }}
                    <br />
                    <label class="info">{{ 'General.Id' | translate }}: {{ item.id }}</label>
                </td>
            </ng-container>
            <ng-container matColumnDef="type">
                <th mat-header-cell *matHeaderCellDef>{{ 'Transactions.Type' | translate }}</th>
                <td mat-cell *matCellDef="let item">
                    {{ item.transactionTypeName }}
                    @if (!!item.transactionTypeDescription) {
                        <br />
                        <label class="info">{{ item.transactionTypeDescription }}</label>
                    }
                </td>
            </ng-container>
            <ng-container matColumnDef="outgoingName">
                <th mat-header-cell *matHeaderCellDef>{{ 'Transactions.OutgoingName' | translate }}</th>
                <td mat-cell *matCellDef="let item">{{ item.outgoingName }}</td>
            </ng-container>
            <ng-container matColumnDef="numberOfShares">
                <th mat-header-cell mat-cell class="text-right" *matHeaderCellDef>{{ 'Transactions.NumberOfShares' | translate }}</th>
                <td mat-cell class="text-right" *matCellDef="let item">
                    {{ item.numberOfShares | slNumber }}
                </td>
            </ng-container>
            <ng-container matColumnDef="arrow">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell class="text-right" *matCellDef="let item">
                    <svg class="arrow" width="47" height="16" viewBox="0 0 47 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M1.14937 7.6549L45.8929 7.6549M45.8929 7.6549L38.8402 0.602295M45.8929 7.6549L38.8402 14.7075"
                            stroke="#708087"
                            stroke-linecap="round"
                            stroke-linejoin="round" />
                    </svg>
                </td>
            </ng-container>
            <ng-container matColumnDef="incomingName">
                <th mat-header-cell *matHeaderCellDef>{{ 'Transactions.IncomingName' | translate }}</th>
                <td mat-cell *matCellDef="let item">{{ item.incomingName }}</td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns" (click)="goToView(row)"></tr>
        </table>
    </mat-card-content>
</mat-card>
